import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const VIPManagementModal = ({ isOpen, onClose, onSaveVIPData }) => {
  const [vipData, setVipData] = useState({
    clientId: '',
    vipTier: '',
    assignedAgent: '',
    specialRequests: '',
    preferredContactMethod: '',
    preferredContactTime: '',
    dedicatedSupport: false,
    priorityViewing: false,
    exclusiveListings: false,
    conciergeService: false,
    personalizedReports: false,
    anniversaryDate: '',
    preferences: '',
    notes: ''
  });

  const handleChange = (field, value) => {
    setVipData(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckbox = (field) => {
    setVipData(prev => ({ ...prev, [field]: !prev?.[field] }));
  };

  const handleSave = () => {
    onSaveVIPData?.(vipData);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="إدارة عملاء VIP" size="lg" footer={null} icon={null} iconColor={null}>
      <div className="space-y-4 max-h-[70vh] overflow-y-auto">
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-amber-400">
            <Icon name="Star" size={20} />
            <span className="font-semibold">تعيين وإدارة خدمات VIP</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">رقم العميل</label>
            <Input
              placeholder="مثال: CL-2026-001"
              value={vipData?.clientId}
              onChange={(e) => handleChange('clientId', e?.target?.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">مستوى VIP</label>
            <Select
              value={vipData?.vipTier}
              onChange={(e) => handleChange('vipTier', e?.target?.value)}
            >
              <option value="">اختر المستوى</option>
              <option value="platinum">بلاتينيوم</option>
              <option value="gold">ذهبي</option>
              <option value="silver">فضي</option>
            </Select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الوكيل المخصص</label>
          <Select
            value={vipData?.assignedAgent}
            onChange={(e) => handleChange('assignedAgent', e?.target?.value)}
          >
            <option value="">اختر الوكيل</option>
            <option value="senior-agent-1">أحمد محمد - وكيل أول</option>
            <option value="senior-agent-2">سارة علي - وكيل أول</option>
            <option value="vip-specialist">محمد خالد - أخصائي VIP</option>
          </Select>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">طريقة التواصل المفضلة</label>
            <Select
              value={vipData?.preferredContactMethod}
              onChange={(e) => handleChange('preferredContactMethod', e?.target?.value)}
            >
              <option value="">اختر الطريقة</option>
              <option value="phone">مكالمة هاتفية</option>
              <option value="whatsapp">واتساب</option>
              <option value="email">بريد إلكتروني</option>
              <option value="in-person">شخصياً</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">وقت التواصل المفضل</label>
            <Select
              value={vipData?.preferredContactTime}
              onChange={(e) => handleChange('preferredContactTime', e?.target?.value)}
            >
              <option value="">اختر الوقت</option>
              <option value="morning">صباحاً (9-12)</option>
              <option value="afternoon">ظهراً (12-3)</option>
              <option value="evening">مساءً (3-6)</option>
              <option value="night">ليلاً (6-9)</option>
            </Select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الخدمات الخاصة</label>
          <div className="space-y-3">
            <Checkbox
              label="دعم مخصص على مدار الساعة"
              checked={vipData?.dedicatedSupport}
              onChange={() => handleCheckbox('dedicatedSupport')}
            />
            <Checkbox
              label="أولوية في معاينة العقارات"
              checked={vipData?.priorityViewing}
              onChange={() => handleCheckbox('priorityViewing')}
            />
            <Checkbox
              label="الوصول إلى قوائم حصرية"
              checked={vipData?.exclusiveListings}
              onChange={() => handleCheckbox('exclusiveListings')}
            />
            <Checkbox
              label="خدمة الكونسيرج"
              checked={vipData?.conciergeService}
              onChange={() => handleCheckbox('conciergeService')}
            />
            <Checkbox
              label="تقارير سوقية مخصصة"
              checked={vipData?.personalizedReports}
              onChange={() => handleCheckbox('personalizedReports')}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ الذكرى السنوية</label>
          <Input
            type="date"
            value={vipData?.anniversaryDate}
            onChange={(e) => handleChange('anniversaryDate', e?.target?.value)}
          />
          <p className="text-xs text-gray-500 mt-1">لإرسال تهاني وعروض خاصة</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الطلبات الخاصة</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            rows="2"
            placeholder="مثال: يفضل العقارات في الطوابق العليا، يحتاج إلى موقف سيارتين..."
            value={vipData?.specialRequests}
            onChange={(e) => handleChange('specialRequests', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">التفضيلات الشخصية</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            rows="2"
            placeholder="مثال: يفضل القهوة العربية في الاجتماعات، يحب الاتصال في الصباح الباكر..."
            value={vipData?.preferences}
            onChange={(e) => handleChange('preferences', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">ملاحظات إضافية</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            rows="2"
            placeholder="أي معلومات مهمة أخرى..."
            value={vipData?.notes}
            onChange={(e) => handleChange('notes', e?.target?.value)}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleSave} className="flex-1 bg-amber-600 hover:bg-amber-700">
            <Icon name="Star" size={18} className="ml-2" />
            حفظ بيانات VIP
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VIPManagementModal;